import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useT } from "@/lib/LanguageContext";
import { crmErrorMessage } from "../api/crmErrors";
import useSequences from "../hooks/useSequences";
import { crmHref } from "../paths";
import CrmPageHeader from "../ui/CrmPageHeader";
import CrmButton from "../ui/CrmButton";
import SlideOver from "../ui/SlideOver";
import SequenceGrid from "../email/SequenceGrid";
import BirthdayCard from "../email/BirthdayCard";
import SendingDomainCard from "../email/SendingDomainCard";
import BroadcastComposer from "../email/BroadcastComposer";
import { CRM } from "../../../constants/testIds/crm";

/**
 * Admin → CRM → Email Automation (spec Screen 6, owner-only — RoleGate at the route):
 * the five system sequences (+ custom), "+ New sequence" (creates a blank draft at once
 * and opens the editor on it), "Send broadcast", the Birthday toggle and the Sending
 * domain block.
 */
export default function CrmEmailAutomation() {
  const t = useT("crm");
  const tc = useT("common");
  const navigate = useNavigate();
  const { create } = useSequences();
  const [creating, setCreating] = useState(false);
  const [composing, setComposing] = useState(false);

  const newSequence = async () => {
    setCreating(true);
    try {
      const seq = await create();
      navigate(crmHref(`/email/sequences/${seq.id}`));
    } catch (e) {
      toast.error(crmErrorMessage(e, t, tc));
    } finally {
      setCreating(false);
    }
  };

  return (
    <div data-testid={CRM.email} className="space-y-6">
      <CrmPageHeader
        title={t("email.pageTitle")}
        actions={(
          <>
            <CrmButton variant="outline" onClick={() => setComposing(true)} data-testid={CRM.emailBroadcast}>
              {t("email.sendBroadcast")}
            </CrmButton>
            <CrmButton disabled={creating} onClick={newSequence} data-testid={CRM.emailNew}>
              {t("email.newSequence")}
            </CrmButton>
          </>
        )}
      />

      <SequenceGrid />
      <BirthdayCard />
      <SendingDomainCard />

      <SlideOver open={composing} onOpenChange={setComposing} title={t("broadcast.title")}>
        <BroadcastComposer onSent={() => setComposing(false)} />
      </SlideOver>
    </div>
  );
}
